import { useEffect, useState } from 'react';
import { getJson } from '../api/client';
import { Badge, Button } from '../components/ui';
import { brl, dataBr, mesAno } from '../lib/format';
import { navigate } from '../router';
import { type Fatura, rotuloSituacao } from './Faturas';
import styles from './screens.module.css';

/**
 * Fatura mais recente da unidade na Home do morador e do proprietário (#140): valor,
 * vencimento e situação, com "Baixar fatura" que abre o detalhe imprimível em um toque.
 * Sem fatura emitida não ocupa espaço (o texto da Home já explica quando ela aparece).
 */
export function FaturaDestaque() {
  const [fatura, setFatura] = useState<Fatura | null>(null);

  useEffect(() => {
    // A API devolve da competência mais nova para a mais antiga.
    void getJson<{ faturas: Fatura[] }>('/api/me/faturas').then((d) =>
      setFatura(d?.faturas?.[0] ?? null),
    );
  }, []);

  if (!fatura) return null;
  return (
    <section aria-label="Sua fatura" className={styles.faturaDestaque}>
      <div>
        <p className="muted">Fatura {mesAno(fatura)}</p>
        <strong className={styles.faturaValor}>{brl(fatura.subtotal)}</strong>
        <p className="muted">
          {fatura.vencimento ? `Vence em ${dataBr(fatura.vencimento)}` : 'Sem vencimento definido'}
        </p>
      </div>
      <div className={styles.faturaAcao}>
        <Badge tone={fatura.situacao === 'pago' ? 'success' : 'warning'}>
          {rotuloSituacao(fatura.situacao)}
        </Badge>
        <Button onClick={() => navigate(`/faturas?fatura=${fatura.id}`)}>Baixar fatura</Button>
      </div>
    </section>
  );
}
